export function getSearchParams() {
  return new URLSearchParams(window.location.search);
}

export function getParameter(param) {
  return getSearchParams().get(param);
}
